var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.91667 8H3.08333C3.72767 8 4.25 8.50368 4.25 9.125V11.375C4.25 11.9963 3.72767 12.5 3.08333 12.5H1.91667C1.27233 12.5 0.75 11.9963 0.75 11.375V9.125C0.75 8.50368 1.27233 8 1.91667 8Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91667 6H8.08333C8.72767 6 9.25 6.50368 9.25 7.125V11.375C9.25 11.9963 8.72767 12.5 8.08333 12.5H6.91667C6.27233 12.5 5.75 11.9963 5.75 11.375V7.125C5.75 6.50368 6.27233 6 6.91667 6Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.9167 3H13.0833C13.7277 3 14.25 3.50368 14.25 4.125V11.375C14.25 11.9963 13.7277 12.5 13.0833 12.5H11.9167C11.2723 12.5 10.75 11.9963 10.75 11.375V4.125C10.75 3.50368 11.2723 3 11.9167 3Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.9167 0H18.0833C18.7277 0 19.25 0.50368 19.25 1.125V11.375C19.25 11.9963 18.7277 12.5 18.0833 12.5H16.9167C16.2723 12.5 15.75 11.9963 15.75 11.375V1.125C15.75 0.50368 16.2723 0 16.9167 0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignal);
export default __webpack_public_path__ + "static/media/Signal.a305e09d2e204e1fa5235f122dca259d.svg";
export { ForwardRef as ReactComponent };